import { ExtensionNames } from '@peekops/peek-extensions-framework/ExtensionHandler'
import { fetchExtendables as upstreamFetchExtendables } from 'customer-flows/gql/queries/extendables'

// Builds the loadable extension payload from an installed extendable's config. The
// mainDependency (name/type/url) is taken straight from config — it must NOT be overridden
// with a hard-coded type, or the wrong extension loads on NGW (regression DEV-9558).
export function buildLoadableExtension(extendable: Extendable, programId?: string) {
  return {
    name: ExtensionNames.FlowExtension,
    data: {
      mainDependency: extendable.config.data.mainDependency,
      runOnSelector: extendable.config.data.runOnSelector ?? undefined,
      keepObservingForDOMChanges: extendable.config.data.keepObservingForDOMChanges || false,
      isGlobalScope: extendable.config.data.isGlobalScope || false,
      config: {
        accessToken: extendable.config.jwtToken,
        programId,
        // Origin the extension's backend is served from (same origin as the
        // bundle). The extension appends its own API path; replaces .
        host: new URL(extendable.config.data.mainDependency.url).origin
      }
    }
  }
}

export default function extendables({ services, callerContext }: CommandArgs) {
  const extensionsLoader = services['extensions/extension-loader']

  async function fetchExtendables({ programId }: { programId?: string } = {}) {
    return await upstreamFetchExtendables(callerContext).then((response) => {
      const extendables = [...response.data.installedExtendables].map((extendable: Extendable) =>
        buildLoadableExtension(extendable, programId)
      )

      return extensionsLoader.loadExtensions(extendables)
    })
  }

  return { fetchExtendables }
}

declare global {
  export type ExtendablesCommands = ReturnType<typeof extendables>

  // Add to global scope
  interface CommandRegistry {
    extendable: ExtendablesCommands
  }
}
